import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import axios from '../axios';

export const getAllCountries = createAsyncThunk(
  'config/getAllCountries',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/countries?is_active=true', {
        headers: { "Content-type": "application/json" }
      });
      return fulfillWithValue(data.countries);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);


export const getKYCServicesTypes = createAsyncThunk(
  'config/getKYCServicesTypes',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/kyc-service_types');
      return fulfillWithValue(data.services);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
)

export const getSystemConfig = createAsyncThunk(
  'config/getSystemConfig',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/agent/config');
      return fulfillWithValue(data.configurations);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
)

export const agencyOfferedServices = createAsyncThunk(
  'config/agencyOfferedServices',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/offered-services');
      return fulfillWithValue(data.services);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCSectionTitles = createAsyncThunk(
  'config/getKYCSectionTitles',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/kyc-section-titles');
      return fulfillWithValue(data.titles);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCMatchingTitles = createAsyncThunk(
  'config/getKYCMatchingTitles',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/questionnaire-title-match');
      return fulfillWithValue(data.data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);
